import React from 'react';
import { CheckIcon, CreditCardIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { packageIncludes } from '../data/salesCopy';
export function OfferSummary() {
  return <section id="offer" className="w-full border-y border-line bg-night-deep" data-id="element-152" data-mp="1eytx374geczb">
      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-5 sm:py-16 lg:py-20" data-id="element-153" data-mp="1a2v1aygspsov">
        <div className="text-center" data-id="element-154" data-mp="mdahkdctirej">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-155" data-mp="ma65ktt42rdb">
            Limited-time offer
          </p>
          <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-156" data-mp="w3vd1rx73ft8">
            The 60% off <span className="text-gold" data-id="element-157" data-mp="r9r3d0wjotog">expires in</span>
          </h2>
          <div className="mt-6" data-id="element-158" data-mp="3kgd4dctmhok">
            <Countdown data-id="element-159" data-mp="3usc2vihgs75u" />
          </div>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-cream-muted" data-id="element-160" data-mp="3ur9djezsics1">
            This price ends tonight. After that, the bundle returns to its regular price.
          </p>
        </div>

        <div className="mt-8 sm:mt-10" data-id="element-161" data-mp="1gj5f1zrl3jul">
          <div className="flex items-baseline justify-between gap-3" data-id="element-162" data-mp="1gi3pyrdqgwtv">
            <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-cream-muted sm:text-xs" data-id="element-163" data-mp="1lbq4kp3gjasb">
              Limited availability — today only
            </span>
            <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-gold sm:text-xs" data-id="element-164" data-mp="tl25dilcgfha">
              68% claimed
            </span>
          </div>
          <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-panel" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Bundles claimed" data-id="element-165" data-mp="12kyol4oysm4y">
            <div className="h-full w-[68%] rounded-full bg-gold" data-id="element-166" data-mp="2e1ydrrg0mkur" />
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-gold/40 bg-panel sm:mt-10" data-id="element-167" data-mp="2j11mblv7f97h">
          <div className="border-b border-line bg-night px-5 py-5 text-center sm:px-10 sm:py-6" data-id="element-168" data-mp="1tcw6en95lqt6">
            <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-cream-muted sm:text-xs" data-id="element-169" data-mp="1odt06zhftejm">
              TeachersKit™ — the complete bundle
            </p>
            <h3 className="mt-2 font-display text-xl uppercase tracking-tight text-cream sm:text-3xl" data-id="element-170" data-mp="1yb7cqo08pj6n">
              6 Volumes + 6 Free Bonuses
            </h3>
          </div>

          <div className="px-5 py-7 sm:px-10 sm:py-9" data-id="element-171" data-mp="15m08d8e3tzdh">
            <ul className="mx-auto grid max-w-xl grid-cols-1 gap-2.5 sm:gap-3" data-id="element-172" data-mp="15jdy30ztx5rk">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-cream-muted" data-id="element-173" data-mp="1fiv1tcvit9kw">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-174" data-mp="rtaigsvggab3" />
                  {item}
                </li>)}
            </ul>

            <p className="mt-7 text-center text-[10px] font-semibold uppercase tracking-[0.14em] text-cream-muted sm:text-xs" data-id="element-175" data-mp="mswizz7x68oo">
              Total real value: <span className="line-through" data-id="element-176" data-mp="339uje8wff8cx">$745</span>
            </p>
            <p className="mt-3 flex items-baseline justify-center gap-3" data-id="element-177" data-mp="2ok6jnc3w8hrb">
              <span className="font-display text-5xl leading-none text-gold sm:text-7xl" data-id="element-178" data-mp="2oi241wwmtub7">$27</span>
              <span className="font-display text-xl text-cream-muted line-through sm:text-2xl" data-id="element-179" data-mp="2tgn5fznmek18">
                $745
              </span>
            </p>
            <p className="mt-3 text-center text-xs font-semibold uppercase tracking-[0.1em] text-cream sm:text-sm" data-id="element-180" data-mp="3m6m14dwblfev">
              You save $718 — 96% discount
            </p>
            <p className="mt-1 text-center text-[10px] font-medium uppercase tracking-[0.14em] text-cream-muted sm:text-xs" data-id="element-181" data-mp="3c8y41hb8rvtj">
              One-time payment · Lifetime access
            </p>

            <div className="mx-auto mt-7 max-w-md" data-id="element-182" data-mp="20u2h782fyo1w">
              <CtaButton size="large" fullWidth placement="offer_card" label="Give me the TeachersKit bundle now" mobileLabel="Get the bundle — $27" note="Covered by our 10-day money-back guarantee." data-id="element-183" data-mp="20vvl4flo6u67" />
            </div>

            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-cream-muted" data-id="element-184" data-mp="279b2h4ez2ial">
              <li className="flex items-center gap-1.5" data-id="element-185" data-mp="300kwv429fv8h">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-186" data-mp="2zxypp5ja7hqs" />
                Secure payment
              </li>
              <li className="flex items-center gap-1.5" data-id="element-187" data-mp="2q1lug3838vtx">
                <MailIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-188" data-mp="2q483666pthdq" />
                PDFs sent to your email
              </li>
              <li className="flex items-center gap-1.5" data-id="element-189" data-mp="1enhumgetkdgy">
                <CreditCardIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-190" data-mp="1ekvmofo0nvy7" />
                Card · Google Pay · Apple Pay
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}